import React from 'react'
import { object, string } from '@calendly/form/validation'
import { Button } from '@calendly/ui/components/button'
import { TextField } from '@calendly/form'

import { useI18n } from 'locales'

import {
  FormWrapper,
  StyledForm,
  FormFieldsWrapper,
  TotalDueSection,
  TotalDueLabel,
  TotalDueAmount,
  PaymentSection,
  PaymentSectionTitle,
  BottomSection,
  StripePlaceholder,
} from './styles'
import { TermsAndPrivacyNotice } from '../package/terms_and_privacy_notice'

/** Hardcoded until invoice totals are wired to the form */
const invoicePrice = '$0.00'

const InvoicePaymentForm = () => {
  const { i18n } = useI18n()

  const validationSchema = object({
    name: string()
      .trim()
      .required(i18n.t('booking.package.validation.name_required'))
      .max(155, i18n.t('booking.package.validation.name_max_length')),
    email: string()
      .trim()
      .required(i18n.t('booking.package.validation.email_required'))
      .email(i18n.t('booking.package.validation.email_invalid')),
  })

  return (
    <FormWrapper>
      <StyledForm
        initialValues={{
          name: '',
          email: '',
        }}
        validationSchema={validationSchema}
        onSubmit={async () => {
          // TODO: invoice payment / capture flow (replace package stripe_payment_intents/capture)
        }}
      >
        <FormFieldsWrapper>
          <TextField
            id="name"
            name="name"
            label={i18n.t('booking.package.name_label')}
            required
            maxLength={155}
            placeholder={i18n.t('booking.package.name_placeholder')}
            autoComplete="name"
          />

          <TextField
            id="email"
            name="email"
            type="email"
            label={i18n.t('booking.package.email_label')}
            placeholder={i18n.t('booking.package.email_placeholder')}
            required
            autoComplete="email"
          />

          <TotalDueSection>
            <TotalDueLabel>
              {i18n.t('booking.package.total_due')}
            </TotalDueLabel>
            <TotalDueAmount>{invoicePrice}</TotalDueAmount>
          </TotalDueSection>

          <PaymentSection>
            <PaymentSectionTitle>
              {i18n.t('booking.package.payment_title')}
            </PaymentSectionTitle>
            <StripePlaceholder>
              TODO: invoice payment element
            </StripePlaceholder>
          </PaymentSection>
        </FormFieldsWrapper>

        <BottomSection>
          <Button type="submit" wide disabled>
            {i18n.t('booking.package.purchase_button')}
          </Button>
          <TermsAndPrivacyNotice />
        </BottomSection>
      </StyledForm>
    </FormWrapper>
  )
}

export default InvoicePaymentForm
